import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import type { MessagingChannel } from "./api";

const MARKS: Record<MessagingChannel, React.ReactNode> = {
  whatsapp: (
    <>
      <rect width="32" height="32" rx="8" fill="#25D366" />
      <path
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinejoin="round"
        d="M16 6.2c-5.5 0-9.9 4.3-9.9 9.6 0 1.9.6 3.7 1.6 5.2L6.4 25.6l4.7-1.5c1.4.8 3.1 1.3 4.9 1.3 5.5 0 9.9-4.3 9.9-9.6S21.5 6.2 16 6.2z"
      />
      <path
        fill="#fff"
        d="M12.6 11.3c.3-.3.8-.3 1 .1l1.1 2.1c.2.4.1.8-.2 1.1l-.7.7c.6 1.3 1.6 2.3 2.9 2.9l.7-.7c.3-.3.7-.4 1.1-.2l2.1 1.1c.4.2.5.7.1 1l-.9.9c-.7.7-1.7.9-2.5.5-2.6-1.1-4.7-3.2-5.8-5.8-.4-.9-.2-1.9.5-2.5z"
      />
    </>
  ),
  telegram: (
    <>
      <rect width="32" height="32" rx="8" fill="#2AABEE" />
      <path
        fill="#fff"
        d="M7.6 15.4 22.9 9.5c.7-.3 1.4.2 1.2 1.1l-2.6 12.2c-.2.9-.8 1.1-1.5.7l-4-2.9-1.9 1.9c-.2.2-.4.4-.8.4l.3-4 7.2-6.5c.3-.3-.1-.4-.5-.2l-8.9 5.6-3.8-1.2c-.8-.3-.8-.8.1-1.2z"
      />
    </>
  ),
};

/** The channel's mark, with a check badge when linked. */
export function ChannelLogo({
  channel,
  linked = false,
  className,
}: {
  channel: MessagingChannel;
  linked?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("relative inline-flex h-8 w-8 shrink-0", className)}>
      <svg viewBox="0 0 32 32" aria-hidden="true" className="h-full w-full">
        {MARKS[channel]}
      </svg>
      {linked && (
        <span className="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-primary-foreground ring-2 ring-background">
          <Check className="h-3 w-3" strokeWidth={3} />
        </span>
      )}
    </span>
  );
}
